"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _temp;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Calculate = (_temp =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Calculate, _React$Component);

  var _super = _createSuper(Calculate);

  function Calculate(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Calculate);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (evt) {
      var target = evt.target;
      var name = target.name;
      var value = target.value;

      _this.setState((0, _defineProperty2["default"])({}, name, Number(value)));
    });
    _this.state = {
      firstNumber: "",
      secondNumber: ""
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Calculate, [{
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        _react["default"].createElement("form", null,
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "field is-horizontal"
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "field-body"
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "field"
        },
        /*#__PURE__*/
        _react["default"].createElement("label", null, "First Number",
        /*#__PURE__*/
        _react["default"].createElement("input", {
          className: "input is-small",
          type: "number",
          name: "firstNumber",
          value: this.state.firstNumber,
          onChange: this.handleChange
        }))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "field"
        },
        /*#__PURE__*/
        _react["default"].createElement("label", null, "Second Number",
        /*#__PURE__*/
        _react["default"].createElement("input", {
          className: "input is-small",
          type: "number",
          name: "secondNumber",
          value: this.state.secondNumber,
          onChange: this.handleChange
        }))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "field"
        },
        /*#__PURE__*/
        _react["default"].createElement("label", null, "Sum",
        /*#__PURE__*/
        _react["default"].createElement("input", {
          className: "input is-small",
          type: "number",
          name: "result",
          value: this.state.firstNumber + this.state.secondNumber,
          readonly: true
        }))))))
      );
    }
  }]);
  return Calculate;
}(_react["default"].Component), _temp);
var _default = Calculate;
exports["default"] = _default;